"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventAsyncGS = exports.EventGS = exports.EventAsyncGSToken = exports.EventGSToken = exports.EventGSHandlerDisposable = void 0;
const gs = require("..");
class EventGSHandlerDisposable {
    constructor(wrapper, event, eventHandler) {
        this.wrapper = wrapper;
        this.event = event;
        this.eventHandler = eventHandler;
        this.wrapper.el.addEventListener(event, eventHandler);
    }
    dispose() { this.wrapper.el.removeEventListener(this.event, this.eventHandler); }
}
exports.EventGSHandlerDisposable = EventGSHandlerDisposable;
/**Return private invoke function ouside to initializer*/
class EventGSToken {
    /**
     * @param hasHandlersCallback  Invoke then event add first handler. Use for assign pipe listeners only when it need (another one start listen)
     */
    constructor(hasHandlersCallback) {
        this._hasHandlersCallback = hasHandlersCallback;
    }
    /** Invoke then event add first handler. Use for assign pipe listeners only when it need (another one start listen)*/
    get hasHandlersCallback() { return this._hasHandlersCallback; }
}
exports.EventGSToken = EventGSToken;
/**Return private invoke function ouside to initializer*/
class EventAsyncGSToken {
    /**
    * @param hasHandlersCallback  Invoke then event add first handler. Use for assign pipe listeners only when it need (another one start listen)
    */
    constructor(hasHandlersCallback) {
        this._hasHandlersCallback = hasHandlersCallback;
    }
    /** Invoke then event add first handler. Use for assign pipe listeners only when it need (another one start listen)*/
    get hasHandlersCallback() { return this._hasHandlersCallback; }
}
exports.EventAsyncGSToken = EventAsyncGSToken;
class EventGS {
    constructor(token) {
        this._handlers = [];
        this._handlersOnce = [];
        this._token = token;
        this._token.invoke = (e) => this.invoke(e);
    }
    addHandler(listener) {
        this.checkFirstHandler();
        this._handlers.push(listener);
        return { dispose: () => this.removeHandler(listener) };
    }
    addOnceHandler(listener) {
        this.checkFirstHandler();
        this._handlersOnce.push(listener);
        return { dispose: () => this.removeHandler(listener) };
    }
    removeHandler(handler) {
        gs.array.remove(this._handlers, handler);
        gs.array.remove(this._handlersOnce, handler);
    }
    invoke(event) {
        this._handlers.forEach((l) => l(event));
        const onceList = [...this._handlersOnce];
        gs.array.clear(this._handlersOnce);
        onceList.forEach((l) => l(event));
    }
    checkFirstHandler() {
        if (this._handlers.length === 0 && this._handlersOnce.length === 0)
            if (this._token.hasHandlersCallback)
                this._token.hasHandlersCallback();
    }
}
exports.EventGS = EventGS;
class EventAsyncGS {
    constructor(token) {
        this._handlers = [];
        this._handlersOnce = [];
        this._token = token;
        this._token.invoke = (e) => __awaiter(this, void 0, void 0, function* () { return yield this.invokeAsync(e); });
    }
    addHandler(listener) {
        this.checkFirstHandler();
        this._handlers.push(listener);
        return { dispose: () => this.removeHandler(listener) };
    }
    addOnceHandler(listener) {
        this.checkFirstHandler();
        this._handlersOnce.push(listener);
        return { dispose: () => this.removeHandler(listener) };
    }
    removeHandler(handler) {
        gs.array.remove(this._handlers, handler);
        gs.array.remove(this._handlersOnce, handler);
    }
    invokeAsync(event) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const handler of this._handlers)
                yield handler(event);
            const onceList = [...this._handlersOnce];
            gs.array.clear(this._handlersOnce);
            for (const handler of onceList)
                yield handler(event);
        });
    }
    checkFirstHandler() {
        if (this._handlers.length === 0 && this._handlersOnce.length === 0)
            if (this._token.hasHandlersCallback)
                this._token.hasHandlersCallback();
    }
}
exports.EventAsyncGS = EventAsyncGS;
//# sourceMappingURL=EventsGS.js.map